import React from "react"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { login, forceLogin, getCurrentUser } from "redux/ducks/User"
import { createRequest } from "utils/request-helper"
import StaffNewForm from "components/Form/StaffNewForm"

class StaffNew extends React.Component {
  state = {
    hasErrors: false,
    formError: "",
  }

  createStaffAccount(values, bag) {
    createRequest(
      {
        method: "POST",
        route: "users?token_scope=campsandcampers",
        data: {
          data: {
            type: "users",
            attributes: {
              email: values.email,
              password: values.password,
              password_confirmation: values.password_confirmation,
              first_name: values.first_name,
              last_name: values.last_name,
              role: "staff",
            },
          },
        },
      },
      response => {
        this.setState({ hasErrors: false })

        const token = response.data.included.find(
          item => item.type === "tokens"
        )
        const accessToken = token.attributes["access-token"]
        const expiresIn = token.attributes["expires-in"]

        this.props.forceLogin(accessToken, expiresIn)
        this.props.getCurrentUser()
        this.props.history.push("/")
      },
      error => {
        this.setState({
          hasErrors: true,
          formError: `Error: ${error.response.status}`,
        })
        bag.setSubmitting(false)
      }
    )
  }

  render() {
    return (
      <StaffNewForm
        handleSubmit={this.createStaffAccount.bind(this)}
        hasErrors={this.state.hasErrors}
        formError={this.state.formError}
      />
    )
  }
}

const mapStateToProps = state => ({
  currentUser: state.user.currentUser,
})

const mapDispatchToProps = dispatch => ({
  login: (email, password) => dispatch(login(email, password)),
  forceLogin: (accessToken, expiresIn) =>
    dispatch(forceLogin(accessToken, expiresIn)),
  getCurrentUser: () => dispatch(getCurrentUser()),
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(StaffNew)
)



// WEBPACK FOOTER //
// ./src/scenes/User/StaffNew/index.js